<div class="version-error-container">
  <div class="content-container p-5">
    <div class="title-message d-flex justify-content-center fw-bold mb-5">
      <mwp-text-translate text="A new version of the site has been posted. Please click the button below to update to the current build." jsonKey="versionError1" />
    </div>
    @if (isLoggedIn) {
      <div class="d-flex justify-content-center mb-5">
        <mwp-text-translate text="You will be logged out and need to log back in once the update is complete." jsonKey="versionError2" />
      </div>
    }
    <div class="d-flex justify-content-center mb-5">
      <button class="mwp-button w-50" (click)="redirectHome()">
        @if (!isLoggedIn) {
          <mwp-text-translate text="Continue" jsonKey="Continue" />
        }
        @if (isLoggedIn) {
          <mwp-text-translate text="Logout And Continue" jsonKey="logoutAndContinue" />
        }
      </button>
    </div>
    <div class="version-section d-flex justify-content-between px-5">
      <div>
        <mwp-text-translate class="me-1" text="Current Version:" jsonKey="currentVersion" />
        {{ currentVersion }}
      </div>
      <div>
        <mwp-text-translate class="me-1" text="New Version:" jsonKey="newVersion" />
        {{ apiVersion }}
      </div>
    </div>
  </div>
</div>